import script from "./ds-form-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./ds-form-field.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__